const GET_DEFAULT_CONTAINER_PROPS = () => ({
  redirects: {
    onBackClick: {
      to: "/"
    }
  }
});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
